module.exports = __webpack_public_path__ + "static/media/pointer.a1fe3355.svg";